<template>
    <div class="about-us-section section container is-boxed-fluid">
        <div class="row">
            <div class="col-7 col-ms-12">
                <h2 class="section-title centered with-line" v-if="['xs', 'sm'].includes($mq)">{{data.title}}</h2>
                <img :src="data.image" alt="">
            </div>
            <div class="col-5 col-ms-12">
                <h2 class="section-title with-line" v-if="['ms', 'md', 'xl', 'hd', 'inf'].includes($mq)">{{data.title}}</h2>
                <p class="description">{{data.description}}</p>
                <a :href="data.cta_action">
                    <button class="button">{{data.cta_text}}</button>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data']
    }
</script>

<style lang="scss">
    .about-us-section{
        .row{
            align-items: center;
            .col-7{
                img{
                    width: 100%;
                }
            }
            @include mq($ms){
                button{
                    width: 100%;
                }
            }
        }
    }
</style>
